import React from 'react';
import { IconText, Text } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import useWhitelabelEnvs from '../../hooks/whitelabel/useWhitelabelEnvs';
import card from '../../images/payment/mercado-pago/card.png';
import store from '../../images/payment/mercado-pago/store.png';
import cash from '../../images/payment/mercado-pago/cash.png';
import phone from '../../images/payment/mercado-pago/phone.png';
import visa from '../../images/payment/visa.svg';
import visaMastercard from '../../images/payment/tarjeta-2.svg';
import visaAmex from '../../images/payment/tarjeta-visa-amex.svg';
import diners from '../../images/payment/diners.svg';
import './PaymentBenefits';

// Banks whose cards qualify for MercadoPago's interest-free installments, with the
// artwork that covers the brands each one accepts. Declared outside the component so
// the array isn't rebuilt on every render. `brands` doubles as the image's alt text.
const PARTICIPATING_BANKS = [
  { name: 'BCP', logo: visa, brands: 'Visa' },
  { name: 'BBVA', logo: visaMastercard, brands: 'Visa, Mastercard' },
  { name: 'INTERBANK', logo: visaAmex, brands: 'Visa, American Express' },
  { name: 'SCOTIABANK', logo: visaMastercard, brands: 'Visa, Mastercard' },
  { name: 'Cencosud', logo: visaMastercard, brands: 'Visa, Mastercard' },
  { name: 'Diners Club', logo: diners, brands: 'Diners' },
];

/**
 * MercadoPagoIcons component.
 * Render the grid of MercadoPago payment benefit icons and copy, plus the
 * participating banks list that sits below it.
 */
const MercadoPagoIcons = () => {
  const { t } = useTranslation('payment');
  const { brand } = useWhitelabelEnvs();
  // TODO: temporary brand-based conditional; this component will be refactored
  // to avoid hardcoding per-brand logic here. No whitelabel feature flag exists
  // yet for "show cash/wallet-balance benefits", so this checks brand directly.
  const showCashAndBalanceBenefits = brand !== 'cds';
  // The participating banks list is CDS-only and rides on the same pending refactor.
  const showParticipatingBanks = brand === 'cds';
  const benefits = [
    {
      img: card,
      text: t('mercadopago_benefits.first', { context: brand }),
    },
    {
      img: store,
      text: t('mercadopago_benefits.second'),
    },
    showCashAndBalanceBenefits && {
      img: cash,
      text: t('mercadopago_benefits.third'),
    },
    showCashAndBalanceBenefits && {
      img: phone,
      text: t('mercadopago_benefits.fourth'),
    },
  ].filter(Boolean);

  return (
    <>
      <div className="payment-benefits-grid">
        {benefits.map((data) => (
          <IconText
            key={data.img}
            iconSize="L"
            label={data.text}
            iconType={data.img}
            fontSize="S"
          />
        ))}
      </div>

      {showParticipatingBanks && (
        <div className="payment-banks">
          <Text size="S">{t('mercadopago_benefits.banks_header_cds')}</Text>

          <ul className="payment-banks-list">
            {PARTICIPATING_BANKS.map(({ name, logo, brands }) => (
              <li className="payment-banks-row" key={name}>
                <Text size="S">{name}</Text>
                <img alt={brands} src={logo} />
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default MercadoPagoIcons;
